import { forwardRef, Ref, type SVGProps } from 'react';

const SvgBookOpenIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m12 21-.1-.15c-.695-1.042-1.042-1.563-1.5-1.941a4 4 0 0 0-1.378-.741c-.569-.174-1.195-.174-2.447-.174H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.873C2 16.475 2 15.915 2 14.795v-8.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h.4c2.24 0 3.36 0 4.216.435a4 4 0 0 1 1.748 1.748C12 6.034 12 7.154 12 9.394zm0 0 .1-.15c.695-1.042 1.042-1.563 1.5-1.941a4 4 0 0 1 1.378-.741c.569-.174 1.195-.174 2.447-.174H18.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.873c.218-.428.218-.988.218-2.108v-8.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218h-.4c-2.24 0-3.36 0-4.216.435a4 4 0 0 0-1.748 1.748C12 6.034 12 7.154 12 9.394z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBookOpenIcon);
export default ForwardRef;
